import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-poi-popup-new',
  templateUrl: './poi-popup-new.component.html',
  styleUrls: ['./poi-popup-new.component.scss']
})
export class PoiPopupNewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
